import { useCallback } from "react"
import * as EventTypeEnum from "../event-type-enum";
import useEventBusListener from "./use-event-bus-listener";

function useOnEntityCreated(entityType = null, entityId = null, onCreated = ({ entityType, entityId, entityData }) => { }) {

    const entityTypeFilter = entityType;
    const entityIdFilter = entityId;
    const eventReceived = useCallback(({ entityId, entityType, entityData }) => {
        if ((entityTypeFilter === null || entityTypeFilter === undefined || entityType === entityTypeFilter) &&
            (entityIdFilter === null || entityIdFilter === undefined || entityId === entityIdFilter))
            onCreated({ entityId, entityType, entityData });
    }, [onCreated, entityTypeFilter, entityIdFilter]);

    useEventBusListener(EventTypeEnum.EntityCreated, eventReceived);

}
export default useOnEntityCreated;